import React from 'react';
import WixAppDevice from '../../../assets/images/wixAppDevice.svg';
import { GradientDivider } from './GradientDivider';

/**
 * Body of the redesigned "Download the Wix app (intro)" step — just the device
 * illustration. The card chrome (title/subtitle/buttons/skip) is provided by
 * `WixAppWizardRedesign`.
 */
export const DownloadAppIntroBody: React.FC = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    }}
  >
    <div style={{ overflow: 'hidden', height: 200, width: '100%' }}>
      <WixAppDevice
        width={275}
        style={{ display: 'block', margin: '0 auto' }}
      />
    </div>
    <GradientDivider />
  </div>
);
